import React, { useEffect, useState } from "react"
import "./SingleBlogPage.scss"
import backgroundSrc from "../assets/bg.jpg"
import BlogItem from "../components/BlogItem/BlogItem"
import BlogDetailedPage from "../BlogDetailedPage/BlogDetailedPage"
import { getAllBlogPosts, getBlogPost } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests"
import { useParams } from "react-router"
import { useSelector } from "react-redux"
import { sortByOrderAscending } from "../helper/helper"

const SingleBlogPage = () => {
    const [data, setData] = useState([])
    const [post, setPost] = useState(null)
    let params = useParams();

    const [isLoading, setIsLoading] = useState(false)
    const [isPostsLoading, setIsPostsLoading] = useState(false)
    const companyDetails = useSelector((state) => state.companyData.company)
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "blogDetailed")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        fetchData()
    }, [params, params.id])
    const fetchData = async () => {
        setIsLoading(true)
        setIsPostsLoading(true)
        let id = companyDetails?.ID ?? ''

        await getBlogPost(params.id, id).then((response) => {
            if (response) {
                setPost(response)
            } else {
                setPost(null)
            }
            setIsLoading(false)

        })
        await getAllBlogPosts(id).then((response) => {
            if (response.data) {
                setData(response.data)
            } else {
                setData([])
            }
            setIsPostsLoading(false)
        })

    }
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatSingleBlogPage-hero-header":
                return <div className="SingleBlogPage-hero-header-cont">
                    <div className="SingleBlogPage-hero-header">{component?.Props?.header}</div>
                    <div className="SingleBlogPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            default:
                return <div />
        }

    }
    const headerComponent = (headerComponents) => {
        return (
            <div className="SingleBlogPage-hero" style={{
                backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
    linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
    linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${headerComponents?.Props?.bgSrc})`
            }}>
                <div className="SingleBlogPage-hero-container">
                    <div className="SingleBlogPage-hero-container-wrapper">
                        {sortByOrderAscending(headerComponents?.Components).map((component, key) => {
                            return (<div key={key}>
                                {getHeaderComponents(component)}
                            </div>)
                        })}

                    </div>
                </div>
            </div>
        )
    }
    const getcontainerContent = (component) => {
        switch (component.ID) {
            case "VirasatSingleBlogPage-blog":
                return isLoading ? <div className="SingleBlogPage-wrapper-emptycontainer"><div className="loader-blog" /></div>
                    :
                    <div className="SingleBlogPage-wrapper-container">
                        <BlogDetailedPage
                            blog={post} />
                    </div>
            case "VirasatSingleBlogPage-grid":
                return <div className="SingleBlogPage-wrapper-container2">
                    <div className="SingleBlogPage-wrapper-container2-header">{component?.Props?.header}</div>
                    <div className="SingleBlogPage-wrapper-container2-subheader">{component?.Props?.subheader}</div>
                    {isPostsLoading ? <div className="loader-blog2" />
                        : <div className="SingleBlogPage-wrapper-container2-grid">
                            {data?.slice(0, 3)?.map((item, key) => {
                                return (
                                    <BlogItem
                                        key={key}
                                        item={item}
                                        isHome={false}
                                        isFilter />
                                )
                            })}

                        </div>}
                </div>
            default:
                return <div />
        }
    }
    const containerComponent = (containerComponents) => {
        return (
            <div className="SingleBlogPage-wrapper">
                {sortByOrderAscending(containerComponents).map((component, key) => {
                    return (
                        getcontainerContent(component)
                    )
                })}
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatSingleBlogPage-hero":
                return headerComponent(component)
            case "VirasatSingleBlogPage-container":
                return containerComponent(component?.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="SingleBlogPage">
            {sortByOrderAscending(Components).map((component, key) => {
                return (getComponents(component))
            })}
        </div>
    )
}
export default SingleBlogPage